// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  elementProps: PropTypes.object
};

MarkdownComponent.defaultProps = {
  elementProps: {}
};

MarkdownComponent['title'] = 'Linux/Other';

MarkdownComponent['slug'] = 'linux';

MarkdownComponent['emoji'] = ':linux:';

function MarkdownComponent(props) {
  const { className, style, elementProps } = props;

  return (
    <div className={className} style={style}>
      <p {...elementProps['p']}>Run the following script (<a href="https://raw.githubusercontent.com/buildkite/agent/master/install.sh" {...elementProps['a']}>view the source</a>), which will download and install the correct binary for your system and architecture:</p>
      <pre {...elementProps['pre']}><code className="language-bash" {...elementProps['code']}>TOKEN=<span className="hljs-string" {...elementProps['span']}>"{ props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE' }"</span> bash -c <span className="hljs-string" {...elementProps['span']}>"`curl -sL https://raw.githubusercontent.com/buildkite/agent/master/install.sh`"</span><br {...elementProps['br']} /></code></pre>
      <p {...elementProps['p']}>Then, start the agent:</p>
      <pre {...elementProps['pre']}><code className="language-bash" {...elementProps['code']}>~/.buildkite-agent/bin/buildkite-agent start<br {...elementProps['br']} /></code></pre>
      <p className="rounded bg-silver p2" {...elementProps['p']}>See the <a href="/docs/agent/linux" {...elementProps['a']}>Linux agent docs</a> for more details.</p>
    </div>
  );
};

export default MarkdownComponent;
